var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBitbnsSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1153 0C25.0189 0 32.2305 7.21156 32.2305 16.1152C32.2305 25.0189 25.0189 32.2304 16.1153 32.2304C7.21158 32.2304 0 25.0189 0 16.1152C0 7.21156 7.21158 0 16.1153 0Z",
    fill: "#9B2AD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.085 21.3664C23.085 20.2921 23.9176 19.5938 24.9651 19.5938C26.0126 19.5938 26.872 20.2921 26.872 21.3664C26.872 22.4408 26.026 23.1794 24.9785 23.1794C23.931 23.1794 23.085 22.4139 23.085 21.3664V21.3664Z",
    fill: "#FF8500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.018 16.8809C23.018 20.7217 20.1979 23.1793 16.5719 23.1793C14.8261 23.1793 13.4295 22.6421 12.4894 21.5812V22.9913H9.38721V6.12402H12.6505V12.0598C13.6175 11.0526 14.9335 10.5826 16.5451 10.5826C20.171 10.5826 22.9912 13.0267 22.9912 16.8809H23.018Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.077 16.9474C20.077 14.8256 18.6669 13.5498 16.7868 13.5498C14.9067 13.5498 13.4832 14.8256 13.4832 16.9474C13.4832 19.0693 14.9067 20.3316 16.7868 20.3316C18.6669 20.3316 20.077 19.0558 20.077 16.9474Z",
    fill: "#9B2AD6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbnsSmall);
export default __webpack_public_path__ + "static/media/bitbnsSmall.ed4b329db5d529fda387ddd9ee9054df.svg";
export { ForwardRef as ReactComponent };